module.exports = __webpack_public_path__ + "656c0c700ef807863ac3998fda8b3d12.svg";